import store from '@/store'
import common_data from '@/common/data'
import dbresults from '@/common/dbresults.js'

export default {
    getMatchedAccessRights(currentPath) {
        var match = []
        if (store.state.user_apps_list) {
            store.state.user_apps_list.every(item => {
                match = item.appPages.filter(x => {
                    //note. don't use includes. should search from root path
                    return currentPath.startsWith(x.pagePath)
                })
                if (match.length>0) return false //stops the forEach loop. does not work in forEach
                return true                      //return true if not found so that the loop continues
            })
        }
        return match
    },
    hasEditRights(currentPath) {
        var matched = this.getMatchedAccessRights(currentPath)
        if (matched.length>0) return matched[0].accessRights.edit
        return false
    },
    hasApproverRights(currentPath) {
        var matched = this.getMatchedAccessRights(currentPath)
        if (matched.length>0) return matched[0].accessRights.approver
        return false
    },
    getStatusDescription(statusCode) {
        return common_data.status_codes.filter(x => {
            return x.statusCode == statusCode
        })[0].statusDescription
    },
    getStatusCode(statusDescription) {
        return common_data.status_codes.filter(x => {
            return x.statusDescription == statusDescription
        })[0].statusCode
    },
    getStatusColor(statusCode) {
        return common_data.status_codes.filter(x => {
            return x.statusCode == statusCode
        })[0].color
    },
    getStatusColorByDesc(statusDescription) {
        var data = common_data.status_codes.filter(x => {
            return x.statusDescription == statusDescription
        })
        
        if (data.length > 0) return data[0].color
        else {
            var data = common_data.description_colors.filter(x => {
                return x.statusDescription == statusDescription
            })
            if (data.length > 0) return data[0].color
            return ''
        }
    },
    getStatusButtonColor(statusCode) {
        return common_data.status_codes.filter(x => {
            return x.statusCode == statusCode
        })[0].buttonColor
    },
    validateDBResponse(code){
        return dbresults.db_errors.filter(x => {
            return x.code==code
        })[0].description
    }
}